import React, {useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { fetchNotices, selectNoticeById } from '../../../store/noticesSlice'

export function Notice() {
  const { id } = useParams()
  const routerHistory = useHistory()
  const dispatch = useDispatch()
  const fetchStatus = useSelector(state => state.notices.fetchStatus)
  useEffect(() => {
    if (fetchStatus === 'idle') {
      dispatch(fetchNotices())
    }
  }, [fetchStatus, dispatch])

  const notice = useSelector(state => selectNoticeById(state, id))

  if (notice) {
    return (
      <div className="container">
        <div className="sub-container">
            <div className="notice-table">
              <table className="highlight t_view_responsive">
                <colgroup>
                  <col style={{width: "150px"}} />
                  <col style={{width: "auto"}} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>제목</th>
                    <td className="table_title">
                      {notice.important && <span>[중요]</span>} {notice.title}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="highlight responsive-table t_view_responsive">
                <colgroup>
                  <col style={{width: "25%"}} />
                  <col style={{width: "25%"}} />
                  <col style={{width: "25%"}} />
                  <col style={{width: "25%"}} />
                  {/* <col style={{width: "100px"}} />
                  <col style={{width: "auto"}} /> */}
                </colgroup>
                <tbody>
                  <tr>
                    <th>작성자</th>
                    <td>{notice.author}</td>
                    <th>작성일</th>
                    <td>{notice.lastModified.slice(0, 10)}</td>
                    {/* <th>조회수</th>
                    <td></td> */}
                  </tr>
                </tbody>
              </table>
              <table className="highlight t_view_responsive">
                <colgroup>
                  <col style={{width: "150px"}} />
                  <col style={{width: "auto"}} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>첨부파일</th>
                    <td>
                      <ol>
                        {notice.attachments && notice.attachments.map((attachment, index) => (
                          <li key={index}>
                            <a className="filelist2" href={attachment.href} target="_blank" rel="noreferrer">{attachment.fname}</a>
                          </li>
                        ))
                        }
                      </ol>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="board_content">
                {/* {notice.content} */}
                <div
                  dangerouslySetInnerHTML={{__html: notice.content}}
                  style={{lineHeight: "2rem", margin: "15px"}}
                >
                </div>
              </div>
              <div className="center-align row">
                  {/* <button className=" waves-light waves-effect button-md " onClick="location.href ='/intro/notices'">　목록　</button> */}
                  <button className=" waves-light waves-effect button-md " onClick={() => routerHistory.push('/intro/notices')}>　목록　</button>
              </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <h3>공지사항이 없습니다.</h3>
  }

  
}